import { startOfMonth, subMonths } from 'date-fns'
import type { ChartRange, SeriesPoint } from '../types'

const MONTHS: Record<ChartRange, number> = {
  all: 24,
  '3m': 3,
  '6m': 6,
  '1y': 12,
  '2y': 24,
}

function seeded(seed: number): () => number {
  let s = seed
  return () => {
    s = (s * 1103515245 + 12345) % 2147483648
    return s / 2147483648
  }
}

/**
 * Deterministic monthly history that ends on the metric's current value, so
 * every chart agrees with the number shown beside it.
 */
export function buildSeries(
  current: number,
  seed: number,
  drift = 0.08,
  months = 24
): SeriesPoint[] {
  const next = seeded(seed)
  const anchor = startOfMonth(new Date())
  const values: number[] = [current]

  for (let i = 1; i < months; i++) {
    const previous = values[0]
    const step = (next() - 0.45) * drift * current
    values.unshift(Math.max(current * 0.7, previous - step))
  }

  return values.map((value, index) => ({
    date: subMonths(anchor, months - 1 - index),
    value: Number(value.toFixed(2)),
  }))
}

export function sliceRange(
  series: SeriesPoint[],
  range: ChartRange
): SeriesPoint[] {
  const months = MONTHS[range]
  return series.slice(Math.max(0, series.length - months))
}

export const chartRanges: ChartRange[] = ['all', '3m', '6m', '1y', '2y']
